// extracted by mini-css-extract-plugin
module.exports = {"rate":"_6c97079b1b--rate--i8fvk","rate_high":"_6c97079b1b--rate_high--o__Qh","rate_low":"_6c97079b1b--rate_low--Q0qtg"};